import { Alert, Button } from "react-bootstrap"
import { cicloActas, puedeCambiarEstado } from "../../../utils/CondiccionAccion"
import BadgeEstados from "../../BadgeEstado"

import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { getActaDetalleHandler } from "../../../handlers/actaDetalle.handler";
import { useGeneralAppStore } from "../../../store/generalAppStore";

const Reparto = ({ amp, amt, acta }) => {

    const { handlerModal, modals } = useGeneralAppStore();
    let actasPrev = cicloActas(amp, acta?.id)?.actasPrev
    let actasPos = cicloActas(amp, acta?.id)?.actasPos

    return (
        <section>
            {
                <>
                    {
                        (amp?.length > 1 && (actasPrev.filter(acta => (acta.estado_id != 8 && acta.estado_id != 12))?.length > 0) && actasPrev.length > 0)
                            ?
                            <>
                                <Alert variant="warning" className="d-flex flex-column gap-2 align-items-center">
                                    <div className="bg-white d-flex flex-column align-items-center gap-2 p-4 border rounded shadow-lg w-100">
                                        <b className="d-flex align-items-center gap-2">Hay actas previas en <BadgeEstados estado_id={actasPrev.find(acta => acta.estado_id != 8)?.estado_id} /></b>
                                        <span className="text-center">Marque sin entregar para enviarla con las actas correspondientes</span>
                                        <div className="d-flex flex-wrap justify-content-center gap-2">
                                            {
                                                amp?.filter(acta => acta?.estado_id == 8).map((acta, index) => {
                                                    return (
                                                        <div key={index}
                                                            className={`bg-warning px-2 rounded pt-1 text-dark fw-bold `}
                                                            style={{ cursor: index == 0 ? "pointer" : "default" }}
                                                            onClick={() => {
                                                                if (index == 0) {
                                                                    getActaDetalleHandler({ estado_id: acta?.estado_id, id: acta?.id })
                                                                }
                                                            }}
                                                        >
                                                            <p className="m-0">Acta - {acta?.numero_acta}</p>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <Button size="sm" variant="warning" className="d-flex gap-2 align-items-center"
                                            onClick={() => { handlerModal({ modal: true, modalName: "actas_sin_entregar" }) }}
                                        ><PersonRemoveIcon /> Sin entregar</Button>
                                    </div>
                                </Alert>

                            </>
                            :
                            <>
                                <Alert variant="warning" className="d-flex flex-column gap-2 align-items-center">
                                    <div className="bg-white d-flex flex-column align-items-center gap-2 p-4 border rounded shadow-lg w-100">
                                        <p className="m-0 d-flex align-items-center gap-2">
                                            <b>El acta esta en reparto</b><LocalShippingIcon />
                                        </p>
                                        {
                                            acta?.notificador &&
                                            <div>
                                                <div className="d-flex flex-column">
                                                    <span className="font-bold ">Notificador </span>
                                                    <span className=""> <b>Nombre: </b>{acta?.notificador?.persona?.nombre}</span>
                                                    <span> <b>Fecha asignado: </b>{acta?.notificador?.fecha_asignado}</span>
                                                </div>
                                            </div>
                                        }
                                        <div className="w-100 ">
                                            <hr className="m-2" />
                                            <p className="m-0 text-center">Si se requiere, puede desasignar las actas en reparto</p>
                                            <Button size="sm" variant="warning" className="d-flex gap-2 align-items-center mx-auto mt-3"
                                                onClick={() => { handlerModal({ modal: true, modalName: "actas_sin_entregar" }) }}
                                            ><PersonRemoveIcon /> Sin entregar</Button>
                                        </div>
                                    </div>
                                </Alert>
                            </>
                    }
                </>
            }
        </section >
    )
}

export default Reparto;